import React from 'react';
import styled, { css } from 'styled-components';
import { IndicatorLayoutComponentProps, Shapeable, Block } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { LinkButton, useLang } from '@shapeable/ui';
import { MetricLayout } from '../entities/metric-layout';
import { ImageValueIntro } from '../entities/image-value-intro';
import { classNames } from '@shapeable/utils';
import { DottedChevronRightHeavyIconGlyph } from '@shapeable/icons';
import { JAPAN_MAP_THUMBNAIL } from '../../data';
const cls = classNames('indicator-layout-feature-count');

// -------- Child Component Props -------->

export type IndicatorLayoutFeatureCountProps = IndicatorLayoutComponentProps & {
};

export const IndicatorLayoutFeatureCountDefaultProps: Omit<IndicatorLayoutFeatureCountProps, 'entity'> = {
};

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    box-sizing: border-box;
    padding: ${theme.UNIT(6)} 0 ${theme.UNIT(2)} 0;
  `,
});

const BodyStyles = breakpoints({
  base: css`
    margin-top: ${theme.UNIT(4)};
  `,
});

const ButtonStyles = breakpoints({
  base: css`
    flex-grow: 1;
    padding-top: ${theme.UNIT(4)};
  `,
});

// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
  Body: styled(ImageValueIntro)`${BodyStyles}`,
  Button: styled(LinkButton)`${ButtonStyles}`,
};

export const IndicatorLayoutFeatureCount: Shapeable.FC<IndicatorLayoutFeatureCountProps> = (props) => {
  const { className, entity } = props;
  const t = useLang();

  const handleButtonClick = React.useCallback(() => {
    if (typeof window === 'undefined') {
      return;
    }

    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }, []);

  // Extract data from the indicator entity
  const { result, name } = entity || {};
  const { indicator } = result || {};
  const { links } = indicator || {};

  const link = !!links?.length && links[0]?.url || links[0]?.path || '#';

  const value = result?.numericValue;


  return (
    <My.Container
      className={className}
      entity={entity}
      ratio={2}
      stretch={true}
      hasPadding={false}
    >
      <My.Body entity={indicator} value={value} />
      {
        !!link && value > 0 && (
          <My.Button variant='slim' href={link} icon={DottedChevronRightHeavyIconGlyph} onClick={handleButtonClick}>
            {t(links?.[0]?.label)}
          </My.Button>
        )
      }
    </My.Container>
  )
};

IndicatorLayoutFeatureCount.defaultProps = IndicatorLayoutFeatureCountDefaultProps;
IndicatorLayoutFeatureCount.cls = cls;